import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import { forwardRef } from 'react';
import { BaseInput } from '../BaseInput/BaseInput.js';
import { useRangeInput } from './useRangeInput.js';

const RangeInput = forwardRef(function RangeInput(props, ref) {
    const { rangeInputProps, rangeInputRef, hasStartDay } = useRangeInput({
        inputProps: props,
        ref,
    });
    return jsx(StyledBaseInput, Object.assign({}, rangeInputProps, { "$hasStartDay": hasStartDay, ref: rangeInputRef }));
});
const StyledBaseInput = styled(BaseInput)(({ theme, $hasStartDay, error }) => (Object.assign({}, (!error && { color: $hasStartDay ? theme.palette.text.high : theme.palette.text.secondary }))));

export { RangeInput };
//# sourceMappingURL=RangeInput.js.map
